<template>
  <div>
    <BaseFrame
      submit-text="提交"
      clearText=""
      :show-ctrls="true"
      :infosArr="infosArr"
      :id="curingReCheck.code"
      :submit-loading="submitLoading"
      @submit="submitReCheckResult"
      @cancel="handleToCuringReCheck"
      idText="复查单号">
      <div slot="content">
        <lk-card title="复查结果信息">
          <lk-Table border :columns="columns" :data="tableData" class="requireRecheckAdd"></lk-Table>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
// import AnTable from '../../components/table';
import CuringReCheckExpand from './CuringReCheckExpand.vue';

export default {
  name: 'curingReCheckRecord',
  components: {
    BaseFrame,
    // AnTable,
  },
  data() {
    return {
      curingReCheckId: null,
      infosArr: [],
      submitLoading: false,
      curingReCheck: {},
      conservationMeasuresArr: ['通风', '除湿', '调节温湿度'],
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(CuringReCheckExpand,
            {
              props: {
                row,
              },
            }),
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 110,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 110,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 110,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 110,
        },
        {
          title: '存疑数量',
          key: 'doubtfulCount',
          minWidth: 110,
        },
        {
          title: '备注',
          key: 'description',
          minWidth: 110,
        },
        {
          title: '正常数量',
          key: 'normalCount',
          minWidth: 110,
          render: (h, { row, index }) => h('lk-input-number', {
            props: {
              value: row.normalCount,
              min: 0,
              max: 1000000000,
              precision: 2,
              activeChange: false,
              placeholder: '请输入',
            },
            on: {
              'on-change': (value) => {
                this.tableData[index].normalCount = value;
                if (value === 0) {
                  this.tableData[index].curingMeasures = '';
                }
              },
            },
          }),
        },
        {
          title: '养护措施',
          key: 'curingMeasures',
          minWidth: 140,
          render: (h, { row, index }) => {
            const options = this.conservationMeasuresArr.map((item, i) => h('lk-option', {
              props: {
                value: i + 1,
              },
            }, item));
            return h('lk-select', {
              props: {
                value: row.curingMeasures,
                placement: 'bottom',
                transfer: true,
                clearable: true,
                multiple: true,
                disabled: row.normalCount === 0,
              },
              on: {
                'on-change': (value) => {
                  this.tableData[index].curingMeasures = value;
                },
              },
            },
            options);
          },
        },
        {
          title: '异常数量',
          key: 'abnormalCount',
          minWidth: 110,
          render: (h, { row, index }) => h('lk-input-number', {
            props: {
              value: row.abnormalCount,
              min: 0,
              max: 1000000000,
              precision: 2,
              activeChange: false,
              placeholder: '请输入',
            },
            on: {
              'on-change': (value) => {
                this.tableData[index].abnormalCount = value;
              },
            },
          }),
        },
        {
          title: '复查备注',
          key: 'reCheckDescription',
          minWidth: 110,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                // console.log(value);

                this.tableData[index].reCheckDescription = e.target.value;
              },
            },
            props: {
              value: row.reCheckDescription,
              placeholder: '请输入',
              maxlength: 50,
            },
          }),
        },
      ],
      tableData: [],
    };
  },
  computed: {},
  methods: {
    getData() {
      inventory.getCuringReCheckById({ id: this.curingReCheckId }).then((res) => {
        if (res.data.status === 200) {
          const { curingReCheck, curingRecheckDetailVoList } = res.data.data;
          this.infosArr = [
            {
              name: '创建人:',
              value: curingReCheck.createUserName,
            },
            {
              name: '创建时间:',
              value: utils.exchangeTime(curingReCheck.createTime),
            },
            {
              name: '养护详情:',
              value: '部分商品存在异常情况，需要进行确认',
            },
          ];
          this.tableData = [];
          curingRecheckDetailVoList.forEach((item) => {
            const result = item.curingReCheckRecord;
            result.goodsType = item.goodsType;
            result.goodsTypeName = item.goodsTypeName;
            this.tableData.push(result);
          });
          this.curingReCheck = curingReCheck;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    submitReCheckResult() {
      const curingReCheckRecords = [];
      let errorMsg = '';
      for (let i = 0, len = this.tableData.length; i < len; i++) {
        const item = this.tableData[i];
        if (item.abnormalCount < 0 || item.normalCount < 0) {
          errorMsg = '请输入正确的数值';
          break;
        }
        if (item.abnormalCount + item.normalCount !== item.doubtfulCount) {
          errorMsg = '正常数量与异常数量之和应当与存疑数量相等';
          break;
        }

        if (!item.reCheckDescription) {
          errorMsg = '复查备注不能为空';
          break;
        }

        if (item.abnormalCount === 0) {
          item.reCheckResult = 1;
        } else {
          item.reCheckResult = 2;
        }
        curingReCheckRecords.push(item);
      }

      if (errorMsg) {
        this.$Message.error(errorMsg);
        return;
      }

      this.submitLoading = true;
      inventory.submitCuringReCheckResult({
        curingReCheck: {
          id: this.curingReCheckId,
        },
        curingReCheckRecords,
      }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          this.handleToCuringReCheck();
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitLoading = false;
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    handleToCuringReCheck() {
      this.$router.push({
        name: 'curingReCheck',
      });
    },
  },
  created() {
    this.curingReCheckId = this.$route.params.id;
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>
